import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { IoTrashOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
import AgregarShippingDoc from './AgregarShippingDoc';
import EditarShippingDoc from './EditarShippingDoc';
import {urlApiProd} from '../utiles';

const ShippingDocs = () => {
    const [dataShippingDocs, setDataShippingDocs] = useState([]);
    const [showAgregar, setShowAgregar] = useState(false);
    const [showEditar, setShowEditar] = useState(false);
    const [selected, setSelected] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const firstRender = useRef(true);
    const [opciones, setOpciones] = useState({
        proformas: [],
    });

    const fetchData = async () => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        try {
            const response = await fetch(`${urlApiProd}/shippingdocs`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.status === 401) {
                throw new Error('Unauthorized');
            }
            const data = await response.json();
            setDataShippingDocs(data);
            
            const opcionesResponse = await fetch(`${urlApiProd}/opciones`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (opcionesResponse.status === 401) {
                throw new Error('Unauthorized');
            }
            const opcionesData = await opcionesResponse.json();
            setOpciones(opcionesData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (firstRender.current) {
            fetchData();
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        const filtered = dataShippingDocs.filter((row) =>
            Object.values(row).some((value) =>
                value.toString().toLowerCase().includes(filterText.toLowerCase())
            )
        );
        setFilteredData(filtered);
    }, [dataShippingDocs, filterText]);

    const columns = [
        {
            name: 'Editar',
            cell: (row) => (
                <button className='btn btn-outline-primary' onClick={() => handleEditar(row)}>
                    <LuPencilLine />
                </button>
            ),
        },
        {
            name: 'Documentos',
            selector: row => row.documentos.join(', '),
        },
        {
            name: 'Destinos',
            selector: row => row.destinos.join(', '),
        },
        {
            name: 'Contenidos',
            selector: row => row.contenidos.join(', '),
        },
        {
            name: 'Proforma',
            selector: row => row.proforma,
        },
        {
            name: 'Direccion 1',
            selector: row => row.direccion1,
        },
        {
            name: 'Direccion 2',
            selector: row => row.direccion2,
        },
        {
            name: 'Eliminar',
            cell: (row) => (
                <button
                    className='btn btn-outline-danger'
                    onClick={() => {
                        if (window.confirm('¿Estas seguro?')) {
                            handleEliminar(row.id_shippingdoc);
                        }
                    }}
                >
                    <IoTrashOutline />
                </button>
            ),
            ignoreRowClick: true,
        },
    ];

    const handleAgregar = () => {
        setShowAgregar(true);
    };

    const handleEditar = (shippingDoc) => {
        setSelected(shippingDoc);
        setShowEditar(true);
    };

    const handleSaveEditar = (editedShippingDoc) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/editarshippingdoc/${editedShippingDoc.id_shippingdoc}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(editedShippingDoc),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al actualizar documento de envío');
            }
            return response.json();
        })
        .then(data => {
            console.log('Documento de envío actualizado:', data);
            alert('Documento de envío actualizado exitosamente');
            window.location.reload();
        })
        .catch(error => {
            console.error('Error:', error);
        });
    };

    const handleCloseEditar = () => {
        setSelected(null);
        setShowEditar(false);
    };

    const handleEliminar = (idShippingDoc) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/eliminarshippingdoc/${idShippingDoc}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
        .then(response => {
            if (response.ok) {
                alert('Documento de envío eliminado correctamente.');
                window.location.reload();
            } else {
                alert('Error al intentar eliminar el documento de envío.');
            }
        })
        .catch(error => {
            console.error('Error de red:', error);
        });
    };

    return (
        <div className='container-fluid'>
            <div className='card'>
                <div className='card-header'>
                    <h3 className='card-title' style={{ textAlign: 'center' }}>Documentos de Envío</h3>
                </div>
                <div className='card-body mb-2'>
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={filterText}
                            onChange={(e) => setFilterText(e.target.value)}
                            className='form-control'
                        />
                    </div>
                    <div className="input-group mb-3">
                        <button type="button" className="btn btn-outline-primary" onClick={handleAgregar}>Agregar Documento de Envío</button>
                    </div>
                    {showAgregar && <AgregarShippingDoc opciones={opciones} cerrar={() => setShowAgregar(false)} />}
                    <div className="card">
                        <div className="card-body">
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                noHeader
                                responsive
                                pagination
                                highlightOnHover
                            />
                        </div>
                    </div>
                    {selected && showEditar && (
                        <EditarShippingDoc
                            shippingDoc={selected}
                            opciones={opciones}
                            cerrar={handleCloseEditar}
                            guardar={handleSaveEditar}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default ShippingDocs;
